import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import ErrorBoundary from './Components/Common/ErrorBoundary';
import Header from './Components/Public/Header';
import Footer from './Components/Public/Footer';
import Us from './Components/Public/Us';
import Contact from './Components/Public/Contact';
import Home from './Components/Public/Home';
import Pricing from './Components/Public/Pricing';
import PortalVirtual from './Components/Public/PortalVirtual';
import Portales from './Components/Public/Portales';
import PortalEstudiantil from './Components/Public/PortalEstudiantil';
import EstudianteDashboard from './Components/Public/EstudianteDashboard';
import PortalLaboral from './Components/Public/PortalLaboral';
import DocenteDashboard from './Components/Public/DocenteDashboard';
import { STUDENT_PORTAL_ENABLED } from './config/studentApi';
import { TEACHER_PORTAL_ENABLED } from './config/teacherApi';

// Componente para el título dinámico
function DynamicTitle() {
  const location = useLocation();
  
  useEffect(() => {
    const path = location.pathname;
    let pageTitle = path === '/'
      ? 'Inicio'
      : path.replace('/', '').replace(/\//g, ' · ').replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
    document.title = `${pageTitle} | CECAP`;
    window.scrollTo(0, 0);
  }, [location]);
  
  return null;
}

function AppLayout() {
  const location = useLocation();
  const isPortalRoute =
    location.pathname === '/portal-virtual'
    || location.pathname.startsWith('/portal-estudiantil')
    || location.pathname.startsWith('/portal-laboral');
  const isPortalSession =
    location.pathname.startsWith('/portal-estudiantil/inicio')
    || location.pathname.startsWith('/portal-laboral/inicio');

  return (
    <>
      <DynamicTitle />
      {!isPortalSession && <Header />}
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/Us" element={<Us />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/portales" element={<Portales />} />
          <Route path="/portal-virtual" element={<PortalVirtual />} />
          <Route path="/portal-estudiantil" element={<PortalEstudiantil />} />
          {STUDENT_PORTAL_ENABLED && (
            <Route path="/portal-estudiantil/inicio/:seccion?" element={<EstudianteDashboard />} />
          )}
          <Route path="/portal-laboral" element={<PortalLaboral />} />
          {TEACHER_PORTAL_ENABLED && (
            <Route path="/portal-laboral/inicio/:seccion?" element={<DocenteDashboard />} />
          )}
        </Routes>
      </main>
      {!isPortalRoute && <Footer />}
    </>
  );
}

// Componente principal de la aplicación
function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AppLayout />
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;